import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 0a12.195 12.195 0 0 0-12.195 12.195 12.2 12.2 0 0 0 2.182 6.955c-10.223 1.694-20.474 5.8-20.474 11.338a30.5 30.5 0 0 0 3.93 14.9l9.95 20.465h2.735L50 99.999l13.873-34.146h2.734l9.95-20.464a30.5 30.5 0 0 0 3.931-14.902c0-5.54-10.258-9.65-20.484-11.342a12.2 12.2 0 0 0 2.191-6.95A12.195 12.195 0 0 0 50 0M32.876 37.79a1.196 1.196 0 0 1 1.19.82l9.77 28.09a1.196 1.196 0 0 1-1.128 1.592H39.2a1.196 1.196 0 1 1 0-2.392h1.825l-9.213-26.509a1.196 1.196 0 0 1 1.063-1.6m34.098 0a1 1 0 0 1 .119 0 1.196 1.196 0 0 1 1.1 1.6l-9.217 26.51H60.8a1.196 1.196 0 1 1 0 2.391h-3.506a1.196 1.196 0 0 1-1.129-1.59l9.77-28.092a1.2 1.2 0 0 1 1.039-.82" />
  </svg>
);
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
